import styled from 'styled-components';

import BackgroundImageLeft from 'assets/delegate/delegate-bg-left.svg?url';
import BackgroundImageRight from 'assets/delegate/delegate-bg-right.svg?url';
import ArrowAlt16 from 'assets/icons/arrows/arrow-alt-16.svg';

import { Button } from 'basics/buttons';
import { ToggleGroup } from 'basics/inputs';
import Select from 'basics/inputs/Select';
import { BlankExternalLink } from 'basics/links';

import { commonMaxWidth, respondDown, respondUp } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Main = styled.main`
    flex: 1 0 auto;
    background-color: ${COLORS.gray50};
`;

export const Background = styled.div`
    width: 100%;
    padding: 8.2rem 24%;
    background-color: ${COLORS.purple900};
    color: ${COLORS.white};
    position: relative;

    ${respondDown(Breakpoints.md)`
         padding: 5rem 5%;
    `}
`;

export const BackgroundLeft = styled.img.attrs({ src: BackgroundImageLeft, alt: '' })`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: auto;
    aspect-ratio: 476 / 413;
    object-fit: contain;

    ${respondDown(Breakpoints.md)`
        height: unset;
        width: 40%;
        top: 50%;
        transform: translateY(-50%);
    `}
`;

export const ButtonStyled = styled(Button)`
    border-radius: 4.6rem;
`;

export const BlankExternalLinkStyled = styled(BlankExternalLink)`
    ${respondDown(Breakpoints.sm)`
        width: 100%
    `}
`;

export const ButtonReadMoreStyled = styled(ButtonStyled)`
    background-color: ${COLORS.purple800};

    ${respondDown(Breakpoints.sm)`
        width: 100%
    `}
`;

export const ArrowAlt16Styled = styled(ArrowAlt16)`
    margin-left: 0.8rem;
    color: ${COLORS.white};
`;

export const BackgroundRight = styled.img.attrs({ src: BackgroundImageRight, alt: '' })`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: auto;
    aspect-ratio: 476 / 413;
    object-fit: contain;

    ${respondDown(Breakpoints.md)`
         height: unset;
         width: 40%;
         top: 50%;
         transform: translateY(-50%);
     `}
`;

export const MainTitle = styled.h2`
    font-weight: 700;
    font-size: 8rem;
    line-height: 9.4rem;
    text-align: center;
    white-space: nowrap;
    position: relative;
    z-index: 1;

    ${respondDown(Breakpoints.sm)`
         font-size: 5rem;
         line-height: 5rem;
    `}

    ${respondDown(Breakpoints.xs)`
         font-size: 3rem;
         line-height: 3rem;
    `}
`;

// Rendered as <div> (not <p>) because the description may contain block-level
// children, which is invalid HTML inside <p> and triggers React hydration warnings.
export const MainDescription = styled.div`
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.8rem;
    text-align: center;
    margin: 1.6rem 0 2.4rem;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const MainLinksContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.8rem;
    margin-top: 2.4rem;

    ${respondDown(Breakpoints.sm)`
        flex-direction: column;
        gap: 1.6rem;
    `}
`;

export const Wrapper = styled.div`
    ${commonMaxWidth};
    margin: 0 auto 10rem;
    padding: 0 10rem;

    ${respondDown(Breakpoints.md)`
        padding: 0 4rem;
        margin: 0 auto 5rem;
    `}

    ${respondDown(Breakpoints.xs)`
        padding: 0 1.6rem;
    `}
`;

export const Title = styled.h2`
    font-weight: 700;
    font-size: 5.6rem;
    line-height: 6.4rem;
    margin-bottom: 3.4rem;
    margin-top: 6.8rem;

    ${respondDown(Breakpoints.md)`
        font-size: 4rem;
        line-height: 5rem;
        margin-top: 3.2rem;
    `}
`;

export const ToggleGroupStyled = styled(ToggleGroup)`
    width: fit-content;
    margin-bottom: 3.2rem;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const SelectStyled = styled(Select)`
    margin-bottom: 3.2rem;

    ${respondUp(Breakpoints.md)`
        display: none;
    `}
`;
